export default function Input({
  id,
  name,
  type = "text",
  label,
  value = "",
  onChange,
  onBlur,
  placeholder,
  required = false,
  disabled = false,
  error,
  autoComplete,
  className = "",
  ...rest
}) {
  const inputId = id ?? (name ? `input-${name}` : undefined);

  return (
    <div className={`ticket__input ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...rest}
      />
      {error && (
        <span
          id={inputId ? `${inputId}-error` : undefined}
          className="ticket__input-error"
          role="alert"
        >
          {error}
        </span>
      )}
    </div>
  );
}
